import { render, staticRenderFns } from "./AscCustomAlertsThresholdWrapper.vue?vue&type=template&id=b550bcfa&"
import script from "./AscCustomAlertsThresholdWrapper.vue?vue&type=script&lang=js&"
export * from "./AscCustomAlertsThresholdWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscCustomAlertsThresholdWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports